import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
// Import operations
import getFolderOperation from 'owa-service/lib/operation/getFolderOperation';
// Import factory
import folderId from 'owa-service/lib/factory/folderId';
import getFolderRequest from 'owa-service/lib/factory/getFolderRequest';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import folderResponseShape from 'owa-service/lib/factory/folderResponseShape';
/**
 * Service call which gets the content of a folder based on shape and properties specified
 * @param targetFolderId - string - the folder id
 * @param isSharedFolder - boolean - indicating if it is a shared folder
 * @param options - options to be sent along with the body
 */
export function getFolder(targetFolderId, isSharedFolder, options) {
    return getFolderOperation({
        Header: getJsonRequestHeader(),
        Body: getFolderRequest({
            FolderShape: folderResponseShape({
                BaseShape: 'IdOnly',
                AdditionalProperties: getAdditionalProperties(isSharedFolder),
            }),
            FolderIds: [folderId({ Id: targetFolderId })],
        }),
    }, options).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
// Helper to get the additional properties to be sent in getFolder request
var getAdditionalProperties = function (isSharedFolder) {
    var additionalProperties = [
        propertyUri({ FieldURI: 'UnreadCount' }),
        propertyUri({ FieldURI: 'TotalCount' }),
    ];
    // We need permissions of the current user on that folder if it is of shared type
    if (isSharedFolder) {
        additionalProperties.push(propertyUri({ FieldURI: 'PermissionSet' }));
    }
    return additionalProperties;
};
//# sourceMappingURL=getFolder.js.map